import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { useSearchDemoMode } from "app/pages/sales-intelligence/modules/leads-search/hooks/useSearchDemoMode";
import type {
    LeadsSearchRequestDto,
    LeadsSearchResponseDto,
    LeadsType,
} from "app/pages/sales-intelligence/modules/leads-search/types";
import { fetchSearchQuotaThunk } from "app/pages/sales-intelligence/sub-modules/advanced-search/store/effects";

import { createLeadsSearchResultsQuery } from "./options";

export function useLeadsSearchResultsQuery<T = LeadsSearchResponseDto>(
    leadsType: LeadsType,
    dto: LeadsSearchRequestDto,
    isEnabled: boolean,
    select?: (data: LeadsSearchResponseDto) => T,
) {
    const dispatch = useDispatch();
    const demoMode = useSearchDemoMode();

    return useQuery(
        createLeadsSearchResultsQuery<T>({
            leadsType,
            dto,
            select,
            demoMode,
            enabled: isEnabled,
            onQuotaError: () => void dispatch(fetchSearchQuotaThunk()),
        }),
    );
}
